// extracted by mini-css-extract-plugin
export default {"card":"ResultSection1_card__Xz78C","subtitleTop":"ResultSection1_subtitleTop__oHHDQ","title":"ResultSection1_title__UJh8f","subtitleBottom":"ResultSection1_subtitleBottom__-w7N1"};